module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-monitoring-c3dad81f8c18ac6174364be69189b352.svg";